/**
 * Api 配置
 * Created by Administrator on 2017/5/18 0018.
 */

import axios from 'axios'
import Vue from 'vue'
// 引入golbal文件，统一管理url
import global_ from '../api/global'
const baseUrl = global_.BASE_URL;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
const service = axios.create({
    baseURL:baseUrl,
    timeout: 15000 ,// 请求超时,
});
//request拦截器
service.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    // 判断是否存在token,如果存在将每个页面header添加token
    let token = localStorage.getItem('token') //localStorage.setItem('token',)
    // config.headers['Authorization'] = token
    // return config
    if (token) {
        config.headers.Authorization = token
        //设置一个定时器，周期性清空localStorage，保证cookie有个过期时间
        setInterval( ()=>{
            // alert('token到期,请重新登录')
            localStorage.removeItem('token');
            window.location.reload(); 
        }, 1000*3600*24);//定时器设置为一天
    }
    return config
}, 
function (error) {
    router.push('login')
    return Promise.reject(error)
})
// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response
}, 
function (error) {
    // 对响应错误做点什么
    if (error.response) {
        switch (error.response.status) {
            case 401:
            router.push('/login')
        }
    }
    return Promise.reject(error)
})
export default service
